import api from '@/services/api/plans.api'

export default {
  state: {
    currencies: [],
    plans: []
  },
  mutations: {
    setCurrencies (state, payload) {
      state.currencies = payload
    },
    setPlans (state, payload) {
      state.plans = payload
    }
  },
  actions: {
    loadAppPlans ({ commit }) {
      return api.getPlans().then(({ data }) => {
        commit('setCurrencies', data.currencies)
        commit('setPlans', data.plans)
      })
    }
  },
  getters: {
    getCurrencies (state) {
      return state.currencies
    },
    getPlans (state) {
      return state.plans
    }
  }
}
